<template>
  <div class="">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <template slot="header" class="clearfix">
            <el-row>
              <el-col :span="24">
                <span class="title"> Variants </span>
              </el-col>
              <el-col :span="24">
                <el-tooltip v-if="id_examination > 0 && selected_exams.length === 0" content="IGV" placement="top" effect="light" :open-delay="500">
                  <el-checkbox v-model="igv_switch" label="IGV" border @change="handle_igv"></el-checkbox>
                </el-tooltip>
              </el-col>
            </el-row>
          </template>

          <el-row>
            <el-col :span="24">
              <div class="category bottom_margin_10">
                <el-tabs class="col-md-12" type="card" v-model="vars_selected_tab" @tab-click="show_tab_click">
                  <el-tab-pane label="Default Filter" name="default">
                    <vars_table />
                  </el-tab-pane>

                  <el-tab-pane label="All Variants" name="all">
                    <vars_table />
                  </el-tab-pane>

                  <el-tab-pane v-if="(selected_exams.length === 0) && (g_project.polyt)" label="PolyT Analysis" name="polyt">
                    <template slot="label">
                      <span>
                        <el-badge v-if="polyt_count >= 0" :value="polyt_count" class="badge_item_last" type="info">
                          <span> PolyT Analysis </span>
                        </el-badge>
                      </span>
                    </template>
                    <el-table
                      :data="polyt_data"
                      style="width: 100%"
                      stripe
                      :default-sort = "{prop: 'coverage', order: 'descending'}"
                      >
                      <el-table-column
                        prop="sample_id"
                        label="Sample ID"
                        min-width="150"
                        sortable
                        >
                      </el-table-column>

                      <el-table-column
                        prop="polyt"
                        label="Genotype"
                        align="center"
                        sortable
                        min-width="150"
                        >
                      </el-table-column>

                      <el-table-column
                        prop="coverage"
                        label="Coverage"
                        align="center"
                        sortable
                        min-width="150"
                        >
                      </el-table-column>

                      <el-table-column
                        prop="freq"
                        label="Frequence (%)"
                        align="center"
                        sortable
                        min-width="150"
                        >
                      </el-table-column>

                      <el-table-column
                        prop="prediction"
                        label="Prediction"
                        align="center"
                        sortable
                        min-width="150"
                        >
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.prediction == true" type="danger"> HIGH </el-tag>
                            <el-tag v-else type="success"> LOW </el-tag>
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="report"
                        label="Report"
                        align="center"
                        sortable
                        min-width="150"
                        >
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.report"> </el-checkbox>
                        </template>
                      </el-table-column>

                    </el-table>
                  </el-tab-pane>

                  <el-tab-pane v-if="true" label="Custom filter" name="custom">
                    <vars_cufi />
                    <el-divider> </el-divider>
                    <vars_table />
                  </el-tab-pane>

                  <el-tab-pane v-if="rapp !== 'fastras' && false" label="Favourite Filters:" name="fav">
                    <div class="row">
                      <div class="col-md-6">
                        <form class="form-horizontal">
                          <h4 slot="header" class="card-title">
                            Save actual custom filter setting as new favourite filter
                          </h4>
                          <div class="row">
                            <label class="col-md-3 col-form-label">Name</label>
                            <div class="col-md-9">
                              <fg-input v-model="filter_name" placeholder=""></fg-input>
                            </div>

                            <label class="col-md-3 col-form-label">Description</label>
                            <div class="col-md-9">
                              <fg-input v-model="filter_description" placeholder=""></fg-input>
                            </div>

                            <label class="col-md-3 col-form-label"></label>
                            <div class="col-md-9">
                              <fg-input placeholder="">
                                <p-checkbox>Share filter</p-checkbox>
                              </fg-input>
                            </div>
                          </div>

                          <div slot="footer" class="row">
                            <div class="col-md-6 mr-auto ml-auto">
                              <el-tooltip content="My description ..." placement="top" effect="light">
                                <el-button type="info" block @click.native="a_filter_save"> SAVE </el-button>
                              </el-tooltip>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-md-6">
                        <el-button-group>
                          <el-button type="primary" size="small" icon="icofont-user-alt-2" @click.native="ff_type(0)"></el-button>
                          <el-button type="primary" size="small" icon="icofont-building-alt" @click.native="ff_type(1)"></el-button>
                          <el-button type="primary" size="small" icon="icofont-globe" @click.native="ff_type(2)"></el-button>
                        </el-button-group>

                        <el-table class=""
                                  ref="f_filters"
                                  :data="f_filters_data"
                                  border
                                  highlight-current-row
                                  @current-change="handleCurrentChange_ff"
                                  style="width: 100%"
                                  size="medium"
                                  empty-text=" "
                                  >
                          <el-table-column
                            v-for="column in tableColumns_ff"
                            :key="column.label"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            :align="column.align"
                            :sortable="column.sortable"
                          >
                          </el-table-column>

                          <el-table-column width="70"
                                          header-align="right"
                                          label="Actions">
                            <div slot-scope="{row}" class="text-right">
                              <el-tooltip content="Info"
                                          :open-delay="300"
                                          placement="top">
                                <el-button type="info" size="sm" icon>
                                  <i class="icofont-info-circle"></i>
                                </el-button>
                              </el-tooltip>

                              <el-tooltip content="Settings"
                                          :open-delay="300"
                                          placement="top">
                                <el-button type="success" size="sm" icon>
                                  <i class="icofont-settings"></i>
                                </el-button>
                              </el-tooltip>

                              <el-tooltip content="Delete"
                                          :open-delay="300"
                                          placement="top">
                                <el-button type="danger" size="sm" icon>
                                  <i class="icofont-trash"></i>
                                </el-button>
                              </el-tooltip>

                            </div>
                          </el-table-column>

                        </el-table>
                      </div>
                    </div>
                  </el-tab-pane>

                  <el-tab-pane :disabled="g_project.cnv_status < 9" v-if="g_project.id_analysis_type < 100 && selected_exams.length === 0" label="CNV" name="cnv">
                    <template slot="label">
                      <span>
                        <el-badge v-if="cnv_count >= 0" :value="cnv_count" class="badge_item_last" type="warning">
                          <span> CNV </span>
                        </el-badge>
                      </span>
                    </template>
                    <cnvs_dufi />
                    <el-divider> </el-divider>
                    <cnvs_table />
                  </el-tab-pane>

                  <el-tab-pane :disabled="true" v-if="g_project.id_analysis_type > 100 && selected_exams.length === 0" label="Fusions" name="fusions">
                    <template slot="label">
                      <span>
                        <el-badge v-if="fu_count >= 0" :value="fu_count" class="badge_item_last" type="warning">
                          <span> Fusions </span>
                        </el-badge>
                      </span>
                    </template>

                    <el-divider> </el-divider>

                  </el-tab-pane>

                  <el-tab-pane v-if="selected_exams.length === 0" label="Preselected Variants" name="presel">
                    <template slot="label">
                      <span>
                        <el-badge v-if="presel_count_snv >= 0" :value="presel_count_snv" class="badge_item" type="primary">
                          <span> Preselected </span>
                        </el-badge>
                        <el-badge v-if="presel_count_cnv >= 0" :value="presel_count_cnv" class="badge_item_last" type="warning">
                          <span> &nbsp; </span>
                        </el-badge>
                      </span>
                    </template>

                    <el-collapse v-model="active_collapses_preselected" @change="change_collapse">
                      <el-collapse-item title=" Variants " name="ps_snv">
                        <vars_table />
                      </el-collapse-item>

                      <el-collapse-item title=" CNV " name="ps_cnv">
                        <cnvs_table />
                      </el-collapse-item>

                      <!-- <el-collapse-item title=" PolyT " name="ps_pt">
                        <div>Simplify the process: keep operating process simple and intuitive;</div>
                        <div>Definite and clear: enunciate your intentions clearly so that the users can quickly understand and make decisions;</div>
                        <div>Easy to identify: the interface should be straightforward, which helps the users to identify and frees them from memorizing and recalling.</div>
                      </el-collapse-item> -->

                    </el-collapse>

                  </el-tab-pane>

                  <el-tab-pane v-if="selected_exams.length === 0" label="Signed out Variants" name="sign">
                    <template slot="label">
                      <span>
                        <el-badge v-if="sign_count_snv >= 0" :value="sign_count_snv" class="badge_item" type="primary">
                          <span> Signed out </span>
                        </el-badge>
                        <el-badge v-if="sign_count_cnv >= 0" :value="sign_count_cnv" class="badge_item_last" type="warning">
                          <span> &nbsp; </span>
                        </el-badge>
                      </span>
                    </template>

                    <el-row>
                      <el-col :span="2" :offset="1">
                        <el-dropdown v-if="id_project > 0 && g_project.id_analysis_type > 0 && g_examination_selected.status === 15">
                          <el-button type="warning" size="small">
                            Actions of Sample <i class="el-icon-arrow-down el-icon--right"></i>
                          </el-button>
                          <el-dropdown-menu v-if="id_biorole > 3" slot="dropdown">
                            <el-dropdown-item icon="icofont-ui-reply" @click.native="sign_out_vars_reset($event)"> Sign-out RESET </el-dropdown-item>
                            <el-dropdown-item icon="icofont-file-pdf" divided @click.native="make_report_vars($event, g_examination.sample_id)"> Make Report - PDF File </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </el-col>

                      <el-col :span="2":offset="1">
                        <!-- <el-dropdown>
                          <el-button type="primary" size="small">
                            Export data of Sample <i class="el-icon-arrow-down el-icon--right"></i>
                          </el-button>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="icofont-listing-box" divided @click.native="export_setup_cols($event)">Select columns for export</el-dropdown-item>
                            <el-dropdown-item icon="icofont-file-excel" divided @click.native="export_all_vars($event)">Export ALL Variants into XLSX File</el-dropdown-item>
                            <el-dropdown-item icon="icofont-file-excel" @click.native="export_grid_vars($event)">Export Variants in Table into XLSX File</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown> -->
                      </el-col>
                    </el-row>

                    <el-collapse v-model="active_collapses_sign_outed" @change="change_collapse">
                      <el-collapse-item title=" Variants " name="so_snv">
                        <vars_table />
                      </el-collapse-item>

                      <el-collapse-item title=" CNV " name="so_cnv">
                        <cnvs_table />
                      </el-collapse-item>

                      <!-- <el-collapse-item title=" PolyT " name="so_pt">
                        <div>Simplify the process: keep operating process simple and intuitive;</div>
                        <div>Definite and clear: enunciate your intentions clearly so that the users can quickly understand and make decisions;</div>
                        <div>Easy to identify: the interface should be straightforward, which helps the users to identify and frees them from memorizing and recalling.</div>
                      </el-collapse-item> -->

                    </el-collapse>

                  </el-tab-pane>
                </el-tabs>

              </div>
            </el-col>
            <el-col :span="24">

            </el-col>
          </el-row>


          <el-divider slot="append" direction="horizontal"></el-divider>

          <div v-if="igv_switch && !global">
            <div id="igv-div"></div>
          </div>

          <!-- <div id="igv-div"></div> -->


        </el-card>
      </el-col>
    </el-row>


    <el-dialog :visible.sync="modal_transcripts" width="70%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" center>
      <h5 slot="title" class="title title-up to_middle">Transcripts</h5>
      <div class="row">
        <el-table class=""
                  ref="Transcripts"
                  :data="transcripts"
                  border
                  highlight-current-row
                  @current-change=""
                  style="width: 100%"
                  size="medium"
                  :row-class-name="tableRowClassName"
                  empty-text=" "
                  >
          <el-table-column v-for="column in tableColumns_transcripts"
                          :key="column.label"
                          :min-width="column.minWidth"
                          :prop="column.prop"
                          :label="column.label"
                          :align="column.align"
                          :sortable="column.sortable"
                          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>


    <el-dialog :visible.sync="modal_pseudopanels" width="60%" :close-on-click-modal="false" :close-on-press-escape="true" :show-close="true" center>
      <h5 slot="title" class="title title-up to_middle">Pseudopanels</h5>
    </el-dialog>


    <el-dialog :visible.sync="modal_acmg" width="75%" :close-on-click-modal="false" :close-on-press-escape="true" :show-close="true">
      <h5 slot="title" class="title"> ACMG classification </h5>
      <el-row :gutter="50">
        <el-col :span="24">
          <el-table :data="acmg_data" stripe style="width: 100%">
            <el-table-column prop="acmg_code" label="ACMG rule" width="200">
            </el-table-column>
            <el-table-column prop="acmg_text" label="Explanation">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>


    <el-dialog :visible.sync="modal_acmg_genebe" width="75%" :close-on-click-modal="false" :close-on-press-escape="true" :show-close="true">
      <h5 slot="title" class="title"> ACMG GENEBE classification </h5>
      <el-row :gutter="50">
        <el-col :span="24">
          <el-table :data="acmg_data_genebe" stripe style="width: 100%">
            <el-table-column prop="acmg_code" label="ACMG GENEBE rule" width="200">
            </el-table-column>
            <el-table-column prop="acmg_text" label="Explanation">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>


    <el-dialog :visible.sync="modal_freq" width="85%" :close-on-click-modal="false" :close-on-press-escape="true" :show-close="true">
      <h5 slot="title" class="title"> {{ freq_type }} </h5>
      <el-row :gutter="50">
        <el-col :span="24">
          <el-table
            :data="freq_data"
            stripe
            style="width: 100%"
            height="500"
            >
            <el-table-column
              prop="id_project"
              label="Project ID"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="name"
              label="Project name"
              min-width="200"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="id_examination"
              label="Sample ID"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="sample_id"
              label="Sample name"
              min-width="200"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="public_name"
              label="Workflow"
              min-width="150"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="freq"
              label="VAF"
              min-width="200"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="dp"
              label="Total Depth"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="gt"
              label="Genotype"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>


    <el-dialog :visible.sync="modal_freq_cnv" width="85%" :close-on-click-modal="false" :close-on-press-escape="true" :show-close="true">
      <h5 slot="title" class="title"> {{ freq_type }} </h5>
      <el-row :gutter="50">
        <el-col :span="24">
          <el-table
            :data="freq_cnv_data"
            stripe
            style="width: 100%"
            height="500"
            >
            <el-table-column
              prop="id_project"
              label="Project ID"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="name"
              label="Project name"
              min-width="150"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="public_name"
              label="Workflow"
              min-width="150"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="id_examination"
              label="Examination ID"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="sample_id"
              label="Sample name"
              min-width="150"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="sc_reads_rat"
              label="Reads Ratio"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="sc_reads_exp"
              label="Reads Expected"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="sc_reads_obs"
              label="Reads Observed"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="sc_bf"
              label="Quality"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="sc_bins"
              label="Bins"
              min-width="100"
              sortable
              align="center"
              >
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>


    <el-dialog :visible.sync="modal_predictors" width="85%" :close-on-click-modal="false" :close-on-press-escape="true" :show-close="true">
      <span slot="footer" class="">
        Source: <a href="https://sites.google.com/site/jpopgen/dbNSFP">dbNSFP v4.3</a>
      </span>

      <el-row v-for="onecat of pred_categories" :gutter="50">
        <el-col :span="24">
          <h4> {{ onecat.tab_label }} </h4>
        </el-col>

        <el-col :span="24">
          <el-table :data="g_predictors_data(onecat.cat)" stripe style="width: 100%">
            <el-table-column
              prop="predictor"
              label="Predictor"
              width="240"
              sortable
              align="left"
              >
              <template slot-scope="scope">
                <a :href="scope.row.predictor_link" target="_blank"> {{ scope.row.predictor }} </a>
              </template>
            </el-table-column>

            <el-table-column
              prop="prediction_code"
              label="Prediction"
              width="300"
              sortable
              align="left"
              >
              <template slot="header" slot-scope="scope">
                <el-popover
                  placement="top"
                  title=""
                  width="600"
                  trigger="hover"
                  content="Prediction based on dbNSFP Rank Score: This score indicates the potential pathogenicity of a genetic variant according to the dbNSFP database."
                  >
                  <span slot="reference"> Prediction <el-button type="text" icon="icofont-info-circle"></el-button> </span>
                </el-popover>
              </template>
              <template slot-scope="scope">
                <b :style="{'color':scope.row.pred_bg}"> {{ scope.row.prediction_code }} </b>
              </template>
            </el-table-column>

            <el-table-column
              prop="rank_score"
              label="Rank Score"
              width="190"
              sortable
              align="left"
              >
              <template slot="header" slot-scope="scope">
                <el-popover
                  placement="top"
                  title=""
                  width="600"
                  trigger="hover"
                  content="Prediction of Potential Variant Effect (dbNSFP Rank Score): The dbNSFP database assigns a rank score to each genetic variant based on its predicted impact on protein function. A higher rank score suggests a greater likelihood of being disease-causing."
                  >
                  <span slot="reference"> Rank Score <el-button type="text" icon="icofont-info-circle"></el-button> </span>
                </el-popover>
              </template>
              <template slot-scope="scope">
                <span> {{ scope.row.rank_score }} </span>
              </template>
            </el-table-column>

            <el-table-column
              prop="raw_score"
              label="Score"
              min-width="300"
              sortable
              align="left"
              >
            </el-table-column>


            <el-table-column
              prop="raw_prediction"
              label="Raw Prediction"
              min-width="300"
              sortable
              align="left"
              >
            </el-table-column>



          </el-table>
        </el-col>

        <el-col v-if="onecat.cat === 3" :span="24">
          <el-divider />
        </el-col>

      </el-row>

    </el-dialog>


    <el-dialog :visible.sync="modal_vars_export" width="60%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" center>
      <h4 slot="title" class="title title-up text-center" style="margin-bottom: 5px;">Variant Export Configuration</h4>

      <el-row justify="center">
        <el-col :span="24" class="text-center" style="font-size: 15px; color: #555; margin-bottom: 5px;">
          <p style="margin-bottom: 3px;">Choose which annotation and quality control (QC) columns should be included in the exported Excel file.</p>
          <p style="font-weight: bold; color: #d9534f; margin-bottom: 8px;">If no columns are selected, all columns will be exported by default (ordered as displayed in the left panel).</p>
        </el-col>
      </el-row>

      <el-row justify="center">
        <el-col :span="24" style="display: flex; justify-content: center;">
          <el-transfer
            v-model="vars_export_my"
            :data="vars_export_all"
            filterable
            target-order="push"
            :titles="['Available Columns', 'Selected Columns']"
            style="width: 100%; max-width: 1200px; display: flex; justify-content: space-between;"
            :props="{ key: 'key', label: 'label' }"
          ></el-transfer>
        </el-col>
      </el-row>

      <template slot="footer">
        <el-button type="success" @click="vars_export_save" style="width: 100%; font-size: 15px; font-weight: bold;">
          Save Selected Columns for Export
        </el-button>
      </template>
    </el-dialog>


  </div>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  // import Button from 'src/components/UIComponents/Button';
  import PPagination from 'src/components/UIComponents/Pagination.vue';
  import Loading from 'src/components/Layout/LoadingMainPanel.vue';
  import vars_cufi from 'src/components/Views/Vars_cufi.vue';
  import cnvs_dufi from 'src/components/Views/Cnvs_dufi.vue';
  import vars_table from 'src/components/Views/Vars_table.vue';
  import cnvs_table from 'src/components/Views/Cnvs_table.vue';

  import igv from 'igv';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import FileSaver from 'file-saver';
  import axios from 'axios';
  import VueUploadComponent from 'vue-upload-component';
  Vue.component('file-upload', VueUploadComponent);

  export default {
    name: 'vars',
    props: {
      global: {
        type: Boolean,
        default: false,
        description: ''
      },
    },
    components: {
      PPagination,
      igv,
      [vars_table.name]: vars_table,
      [vars_cufi.name]: vars_cufi,
      [cnvs_table.name]: cnvs_table,
      [cnvs_dufi.name]: cnvs_dufi,
    },


    data () {
      return {
        selected_vars: [],
        ints_history_data: [],
        ints_partner_data: [],
        freq_type: "",
        active_collapses_preselected: ["ps_snv", "ps_cnv", "ps_pt"],
        active_collapses_sign_outed: ["so_snv", "so_cnv", "so_pt"],
        show: true,

        pred_categories: [
          {
            cat: 6,
            tab_label: "Function predictions - Metascore",
            info_text: ""
          },
          {
            cat: 3,
            tab_label: "Function predictions",
            info_text: ""
          },
          {
            cat: 2,
            tab_label: "Conservation score",
            info_text: ""
          }
        ],

        formdata_np: {
          name: "",
          np_id_workflow: "",
          created_dt: "",
          created_wh: "",

        },

        blackbox: "",
        files: [],
        mytab: "change",

        AC_genes_loading: false,

        searchQuery_hpo: "",

        grid_size: {
          "S": 300,
          "M": 400,
          "L": 600,
          "XL": 800,
          "XXL": 1100,
          "3XL": 1500,
        },

        slider_marks: {
          0: '0',
          10: '10',
          20: '20',
          30: '30',
          40: '40',
          50: '50',
          60: '60',
          70: '70',
          80: '80',
          90: '90',
          100: '100',
        },

        slider_marks_5: {
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
        },

        slider_marks_10: {
          0: '0',
          0.1: '.1',
          0.2: '.2',
          0.3: '.3',
          0.4: '.4',
          0.5: '.5',
          0.6: '.6',
          0.7: '.7',
          0.8: '.8',
          0.9: '.9',
          1: '1',
        },

        var_order_options: [
          {
            value: 1,
            label: 'Clinvar DESC'
          },
          {
            value: 3,
            label: 'Internal Class DESC'
          },
          {
            value: 99,
            label: 'id_var'
          },
        ],
        var_order: 1,

        interpret_id_var: 0,
        interpret_value: 0,

        selects: {
          simple: '',
          multiple: 'ARS'
        },

        l_gt: ["0/1", "1/1"],
        l_impacts: ["LOW", "HIGH", "MODERATE", "MODIFIER"],


        l_search: [
          {
            key: "pos",
            value: "POSITION"
          },
          {
            key: "snp",
            value: "dbSNP"
          },

        ],

        s_search: '',
        searchQuery_v: '',
        propsToSearch_v: [],

        pagination_ff: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50, 100],
          total: 0
        },

        tableColumns_ff: [
          {
            prop: 'id_filter',
            label: 'ID',
            minWidth: 50,
            align: "right",
            sortable: false,
          },
          {
            prop: 'name',
            label: 'NAME',
            minWidth: 100,
            align: "left",
            sortable: false,
          },
          {
            prop: 'short_text',
            label: 'SHORT',
            minWidth: 100,
            align: "left",
            sortable: false,
          },
          {
            prop: 'status',
            label: 'S.',
            minWidth: 40,
            align: "center",
            sortable: false,
          },
          {
            prop: 'made',
            label: 'MADE',
            minWidth: 80,
            align: "center",
            sortable: false,
          },

        ],

        pagination_hpo: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5,10],
          total: 0
        },

        searchQuery_cnv: '',

        tableColumns_transcripts: [
          {
            prop: 'a_4',
            label: 'Gene',
            minWidth: 130,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_7',
            label: 'Feature',
            minWidth: 130,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_11',
            label: 'HGVSc',
            minWidth: 120,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_12',
            label: 'HGVSp',
            minWidth: 120,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_9',
            label: 'Exon',
            minWidth: 60,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_10',
            label: 'Intron',
            minWidth: 60,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_3',
            label: 'Impact',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_2',
            label: 'Conseq',
            minWidth: 160,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_13',
            label: 'cDNA',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_14',
            label: 'CDS',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_15',
            label: 'Protein',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_16',
            label: 'Amino acids',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_17',
            label: 'Codons',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_19',
            label: 'Distance',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
          {
            prop: 'er',
            label: 'ER',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
        ],

      }
    },

    computed: {
      ...mapState({
        vars: state => state.vars,
        f_filters: state => state.f_filters,
        u_filters: state => state.u_filters,
        hpo: state => state.hpo,
        l_gene: state => state.l_gene,
        l_consequences: state => state.l_consequences,
        l_features: state => state.l_features,
        l_clinvars: state => state.l_clinvars,
        l_clinvar_dns: state => state.l_clinvar_dns,
        l_iclasses: state => state.l_iclasses,
        d_acmg_sigs: state => state.d_acmg_sigs,
        d_a_cols: state => state.d_a_cols,
        d_filter: state => state.d_filter,

        cufi: state => state.cufi,
        cufi_yes: state => state.cufi_yes,
        id_project: state => state.id_project,
        id_workflow: state => state.id_workflow,
        id_examination: state => state.id_examination,
        selected_exams: state => state.selected_exams,
        pagination_v: state => state.pagination_v,
        sorting_v: state => state.sorting_v,
        loading_v: state => state.loading_v,
        loading_cnv: state => state.loading_cnv,

        vars_order: state => state.vars_order,
        vars_selected: state => state.vars_selected,
        cnvs_selected: state => state.cnvs_selected,
        user_setup: state => state.user_setup,

        pan_new_project: state => state.pan_new_project,
        pan_project: state => state.pan_project,

        transcripts: state => state.transcripts,
        igv_on: state => state.igv_on,
        igv_sest: state => state.igv_sest,
        igv_coord: state => state.igv_coord,

        token: state => state.token,
        user: state => state.user,
        id_biorole: state => state.id_biorole,
        subject: state => state.subject,
        application: state => state.application,
        app: state => state.app,
        rapp: state => state.rapp,
        app_version: state => state.app_version,
        modal_acmg: state => state.modal_acmg,
        modal_acmg_genebe: state => state.modal_acmg_genebe,
        acmg_data: state => state.acmg_data,
        acmg_data_genebe: state => state.acmg_data_genebe,
        polyt_data: state => state.polyt_data,
        cnv_data: state => state.cnv_data,
        cnv_count: state => state.cnv_count,
        polyt_count: state => state.polyt_count,
        fu_count: state => state.fu_count,
        presel_count_snv: state => state.presel_count_snv,
        presel_count_cnv: state => state.presel_count_cnv,
        sign_count_snv: state => state.sign_count_snv,
        sign_count_cnv: state => state.sign_count_cnv,

        modal_freq: state => state.modal_freq,
        modal_freq_cnv: state => state.modal_freq_cnv,
        freq_data: state => state.freq_data,
        freq_cnv_data: state => state.freq_cnv_data,


      }),

      ...mapGetters({
        g_gene: 'g_gene',
        g_examination: 'g_examination',
        g_examination_export: 'g_examination_export',
        g_examination_selected: 'g_examination_selected',
        g_project: 'g_project',
        g_iclasses: 'g_iclasses',
        g_iclasses_style: 'g_iclasses_style',
        g_predictors_data: 'g_predictors_data',

        }),

      pagedData_v () {
        return this.vars.slice(this.from_v, this.to_v)
      },

      vars_mydata () {
        if (!this.searchQuery_v) {
          return this.pagedData_v
        }
        let result = this.vars
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_v) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_v)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_v.total = result.length
        return result.slice(this.from_v, this.to_v)
      },


      vars_data () {
        if (!this.searchQuery_v) {
          this.pagination_v.total = this.vars.length
          return this.pagedData_v
        }
        let result = this.vars
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_v) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_v)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_v.total = result.length
        return result.slice(this.from_v, this.to_v)
      },


      to_v () {
        let highBound = this.from_v + this.pagination_v.perPage
        if (this.total_v < highBound) {
          highBound = this.total_v
        }
        return highBound
      },

      from_v () {
        return this.pagination_v.perPage * (this.pagination_v.currentPage - 1)
      },

      total_v () {
        this.pagination_v.total = this.vars.length
        return this.vars.length
      },


      pagedData_ff () {
        return this.f_filters.slice(this.from_ff, this.to_ff)
      },

      f_filters_data () {
        if (!this.searchQuery_ff) {
          this.pagination_ff.total = this.f_filters.length
          return this.pagedData_ff
        }
        let result = this.f_filters
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_ff) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_ff)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_ff.total = result.length
        return result.slice(this.from_ff, this.to_ff)
      },

      to_ff () {
        let highBound = this.from_ff + this.pagination_ff.perPage
        if (this.total_ff < highBound) {
          highBound = this.total_ff
        }
        return highBound
      },

      from_ff () {
        return this.pagination_ff.perPage * (this.pagination_ff.currentPage - 1)
      },

      total_ff () {
        this.pagination_ff.total = this.f_filters.length
        return this.f_filters.length
      },

      pagedData_hpo () {
        return this.hpo.slice(this.from_hpo, this.to_hpo)
      },

      hpo_data () {
        if (!this.searchQuery_hpo) {
          this.pagination_hpo.total = this.hpo.length
          return this.pagedData_hpo
        }
        let result = this.hpo
          .filter((row) => {
            let isIncluded = false
            let rowValue = row["hpo_term_name"].toString()
            if (rowValue.includes && rowValue.includes(this.searchQuery_hpo)) {
              isIncluded = true
            }
            return isIncluded
          })
        this.pagination_hpo.total = result.length
        return result.slice(this.from_hpo, this.to_hpo)
      },

      to_hpo () {
        let highBound = this.from_hpo + this.pagination_hpo.perPage
        if (this.total_hpo < highBound) {
          highBound = this.total_hpo
        }
        return highBound
      },

      from_hpo () {
        return this.pagination_hpo.perPage * (this.pagination_hpo.currentPage - 1)
      },

      total_hpo () {
        this.pagination_hpo.total = this.hpo.length
        return this.hpo.length
      },


      slider_value: {
        get () { return this.$store.state.slider_value; },
        set (value) { this.$store.commit('m_slider_value', value); }
      },


      filter_name: {
        get () { return this.$store.state.ff_name; },
        set (value) { this.$store.commit('m_ff_name', value); }
      },

      filter_description: {
        get () { return this.$store.state.ff_description; },
        set (value) { this.$store.commit('m_ff_description', value); }
      },

      search_vars_by_select: {
        get () { return this.$store.state.search_vars_by_select; },
        set (value) { this.$store.commit('m_search_vars_by_select', value); }
      },

      search_vars_by_value: {
        get () { return this.$store.state.search_vars_by_value; },
        set (value) { this.$store.commit('m_search_vars_by_value', value); }
      },

      igv_switch: {
        get () { return this.$store.state.igv_switch; },
        set (value) { this.$store.commit('m_igv_switch', value); }
      },

      fastras_freq: {
        get () { return this.$store.state.fastras_freq; },
        set (value) { this.$store.commit('m_fastras_freq', value); }
      },

      var_page: {
        get () { return this.$store.state.var_page; },
        set (value) { this.$store.commit('m_var_page', value); }
      },

      vars_selected_tab: {
        get () { return this.$store.state.vars_selected_tab; },
        set (value) { this.$store.commit('m_vars_selected_tab', value); }
      },

      // modal_interpretation: {
      //   get () { return this.$store.state.modal_interpretation; },
      //   set (value) { this.$store.commit('m_modal_interpretation', value); }
      // },

      modal_vars_export: {
        get () { return this.$store.state.modal_vars_export; },
        set (value) { this.$store.commit('m_modal_vars_export', value); }
      },

      modal_transcripts: {
        get () { return this.$store.state.modal_transcripts; },
        set (value) { this.$store.commit('m_modal_transcripts', value); }
      },

      modal_pseudopanels: {
        get () { return this.$store.state.modal_pseudopanels; },
        set (value) { this.$store.commit('m_modal_pseudopanels', value); }
      },

      modal_acmg: {
        get() { return this.$store.state.modal_acmg; },
        set(value) { this.$store.commit('m_modal_acmg', value); }
      },

      modal_acmg_genebe: {
        get() { return this.$store.state.modal_acmg_genebe; },
        set(value) { this.$store.commit('m_modal_acmg_genebe', value); }
      },

      modal_freq: {
        get() { return this.$store.state.modal_freq; },
        set(value) { this.$store.commit('m_modal_freq', value); }
      },

      modal_freq_cnv: {
        get() { return this.$store.state.modal_freq_cnv; },
        set(value) { this.$store.commit('m_modal_freq_cnv', value); }
      },

      modal_predictors: {
        get() { return this.$store.state.modal_predictors; },
        set(value) { this.$store.commit('m_modal_predictors', value); }
      },


      vars_export_all: {
        get () { return this.$store.state.vars_export_all; },
        set (value) { this.$store.commit('m_vars_export_all', value); }
      },

      vars_export_my: {
        get () { return this.$store.state.vars_export_my; },
        set (value) { this.$store.commit('m_vars_export_my', value); }
      },


    },


    methods: {
      ...mapMutations({
        m_slider_value: 'm_slider_value',
        m_igv_switch: 'm_igv_switch',
        m_igv_on: 'm_igv_on',
        m_igv_sest: 'm_igv_sest',
        m_igv_coord: 'm_igv_coord',
        m_var_page: 'm_var_page',
        m_ss_gene: 'm_ss_gene',
        m_vars: 'm_vars',
        m_vars_selected_tab: 'm_vars_selected_tab',
        m_vars_order: 'm_vars_order',
        m_vars_selected: 'm_vars_selected',
        m_cnvs_selected: 'm_cnvs_selected',
        m_id_examination: 'm_id_examination',
        m_modal_acmg: 'm_modal_acmg',
        m_modal_acmg_genebe: 'm_modal_acmg_genebe',
        m_modal_freq: 'm_modal_freq',
        m_modal_freq_cnv: 'm_modal_freq_cnv',
        m_modal_predictors: 'm_modal_predictors',
        m_cufi_selected: 'm_cufi_selected',
        m_cufi_load: 'm_cufi_load',

        m_modal_interpretation: 'm_modal_interpretation',
        // m_modal_transcripts: 'm_modal_transcripts',
        m_modal_vars_export: 'm_modal_vars_export',
        m_transcripts: 'm_transcripts',
        m_fastras_freq: 'm_fastras_freq',

        m_vars_export_all: 'm_vars_export_all',
        m_vars_export_my: 'm_vars_export_my',

        m_d_cufis: 'm_d_cufis',
        m_l_cufis: 'm_l_cufis',

      }),

      ...mapActions({
        a_varsall: 'a_varsall',
        a_vars: 'a_vars',
        a_f_filters: 'a_f_filters',
        a_filter_save: 'a_filter_save',
        a_change_interpretation: 'a_change_interpretation',
        a_anots: 'a_anots',
        a_cnvs: 'a_cnvs',
        a_dufis_get: 'a_dufis_get',
        a_notify: 'a_notify',
        a_examinations: 'a_examinations',
        a_examinations_refresh: 'a_examinations_refresh',
        a_acmg_data: 'a_acmg_data',
        a_acmg_data_genebe: 'a_acmg_data_genebe',
        a_freq_data: 'a_freq_data',
        a_hpo_get: 'a_hpo_get',
        a_predictors_data: 'a_predictors_data',

      }),


      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`)
      },

      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },

      handleDelete (index, row) {
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          this.tableData.splice(indexToDelete, 1)
        }
      },

      tableRowClassName({row, rowIndex}) {
        if (row.er === 1) {
          return 'success-row';
        } else if (row.er === -1) {
          return 'danger-row';
        } else {
          return 'row_0';
        }
      },


      tableRowClassNameVars({row, rowIndex}) {
        // if (row.var_status === 2) {
        //   return 'info-row';
        // } else if (row.var_status === 1) {
        //   return 'row_0';
        // } else {
        //   return 'row_0';
        // }
        return 'row_0';
      },


      canSelectRow() {

      },


      submit_np() {

      },

      handle_transcripts( index, row, event ) {
        event.stopImmediatePropagation();
        this.m_transcripts([]);
        this.m_modal_transcripts(true);
        this.a_anots( {"id_var": row.id_var } );
        // resolve(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // console.log(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // resolve(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // let mypayload = { "id_var": tree.id_var, "er": this.cufi.er_switch };
      },


      async handle_igv( event ) {
        if (this.igv_switch) {
          axios.get(process.env.VUE_APP_BE + '/get_igv_id', { withCredentials: true, params: { "id_examination": this.id_examination  }, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', }, })
              .then(response => {
                let bam_url = process.env.VUE_APP_BE + "/get_bam/" + this.subject.id_subject + "/" + response.data["igv_bam"] + ".bam";
                let bai_url = process.env.VUE_APP_BE + "/get_bai/" + this.subject.id_subject + "/" + response.data["igv_bai"] + ".bam.bai";
                let bam_name = response.data["bam_name"];
                let bed_path = response.data["bed_path"];

                let gff3_url      = process.env.VUE_APP_BE + "/get_metadata_file/" + this.subject.id_subject + "/" + response.data["igv_gff3"] + ".gff3";
                let seg_url       = process.env.VUE_APP_BE + "/get_metadata_file/" + this.subject.id_subject + "/" + response.data["igv_seg"] + ".seg";
                let bedgraph_url  = process.env.VUE_APP_BE + "/get_metadata_file/" + this.subject.id_subject + "/" + response.data["igv_bedgraph"] + ".bedgraph";
                let vcf_url       = process.env.VUE_APP_BE + "/get_metadata_file/" + this.subject.id_subject + "/" + response.data["igv_vcf"] + ".vcf";
                let bed_cnv_url   = process.env.VUE_APP_BE + "/get_metadata_file/" + this.subject.id_subject + "/" + response.data["igv_cnv_bed"] + ".bed";

                // let bam_url = process.env.VUE_APP_STATIC + "static/278-21B_S12_so_rmdp.bam";
                // let bai_url = process.env.VUE_APP_STATIC + "static/278-21B_S12_so_rmdp.bam.bai";

                var igvDiv = document.getElementById("igv-div");
                var options = {
                    showNavigation: true,
                    showRuler: true,
                    supportQueryParameters: true,
                    reference: {
                      id: "hg38",
                      name: "Human (GRCh38/hg38)",
                      fastaURL: "https://s3.amazonaws.com/igv.broadinstitute.org/genomes/seq/hg38/hg38.fa",
                      indexURL: "https://s3.amazonaws.com/igv.broadinstitute.org/genomes/seq/hg38/hg38.fa.fai",
                      cytobandURL: "https://s3.amazonaws.com/igv.org.genomes/hg38/annotations/cytoBandIdeo.txt.gz",
                      aliasURL: "https://s3.amazonaws.com/igv.org.genomes/hg38/hg38_alias.tab"
                    },
                    locus: "all",
                    loadDefaultGenomes: false,
                    showCursorGuide: true, // show cursor guide
                    showCenterGuide: true,   // Enable the center line
                    tracks: [],

                };

                if (true) {
                  options.tracks.push(
                    {
                      type: "alignment",
                      name: bam_name,
                      format: "bam",
                      url: bam_url,
                      indexURL: bai_url,
                      alignmentRowHeight: 11,
                      samplingWindowSize: 200,
                      height: 300,
                      displayMode: "expanded", // or "expanded", "collapsed"
                      showSoftClips: false,     // Shows soft-clipped bases if any
                      viewAsPairs: true,       // Show paired-end reads
                      visibilityWindow: 1000000, // Set a higher value if needed for viewing larger regions
                    }
                  )
                }

                if (response.data["igv_vcf"] !== "") {
                  options.tracks.push(
                    {
                      type: "variant",
                      format: "vcf",
                      url: vcf_url,
                      name: "Variants",
                      squishedCallHeight: 1,
                      expandedCallHeight: 4,
                      displayMode: "COLLAPSED",
                      visibilityWindow: -1
                    }
                  )
                }

                if (true) {
                  options.tracks.push(
                    {
                      name: "Refseq Reference",
                      url: "https://s3.amazonaws.com/igv.org.genomes/hg38/refGene.sorted.txt.gz",
                      indexURL: "https://s3.amazonaws.com/igv.org.genomes/hg38/refGene.sorted.txt.gz.tbi",
                      order: 1000000,
                      indexed: false,
                      height: 100,
                      displayMode: "COLLAPSED",
                    }
                  )
                }

                if (true) {
                  options.tracks.push(
                    {
                      type: "variant",
                      format: "vcf",
                      url: process.env.VUE_APP_STATIC + "static/clinvar.vcf.gz",
                      indexURL: process.env.VUE_APP_STATIC + "static/clinvar.vcf.gz.tbi",
                      name: "ClinVar",
                      squishedCallHeight: 1,
                      expandedCallHeight: 4,
                      displayMode: "COLLAPSED",
                      visibilityWindow: 1000
                    }
                  )
                }

                if (true) {
                  options.tracks.push(
                    {
                      type: "annotation",
                      format: "bed",
                      url: process.env.VUE_APP_STATIC + bed_path,
                      name: "Panel Target",
                      squishedCallHeight: 1,
                      expandedCallHeight: 4,
                      displayMode: "COLLAPSED",
                      visibilityWindow: -1
                    }
                  )
                }

                if (response.data["igv_bedgraph"] !== "") {
                  options.tracks.push(
                    {
                      type: "wig",
                      name: "CNV Visualization",
                      url: bedgraph_url,
                      min: 0,    // Adjust min value to fit your BedGraph scores
                      max: 2,    // Adjust max value to fit your BedGraph scores
                      height: 70,
                      itemRgb: "on", // Enable RGB coloring for items
                      visibilityWindow: 1000000,
                      graphType: "points",
                      // Define a color function for each point based on value
                      itemColor: (value) => {
                          const centralLineValue = 1; // Define the central line value
                          if (value > centralLineValue) {
                              return 'rgb(0, 0, 0)'; // Black for duplication (above central line)
                          } else {
                              return 'rgb(255, 0, 0)'; // Red for deletion (below central line)
                          }
                      },
                      guideLines: [
                          { color: 'rgb(0, 255, 0)', dotted: false, y: 1 }, // Central line in green
                          { color: 'rgb(255, 0, 0)', dotted: false, y: 0.5 }, // Deletion line in red
                          { color: 'rgb(0, 0, 255)', dotted: false, y: 1.5 }  // Duplication line in blue
                      ],
                      displayMode: "EXPANDED"
                    }
                  )
                }

                // if (response.data["igv_seg"] !== "") {
                //   options.tracks.push(
                //     {
                //         type: "seg",
                //         name: "Segmentation Data",
                //         url: seg_url,
                //         color: "rgb(255, 0, 0)",
                //         height: 100,
                //         displayMode: "EXPANDED",
                //         visibilityWindow: -1
                //     }
                //   )
                // }

                if (response.data["igv_gff3"] !== "") {
                  options.tracks.push(
                    {
                      type: "annotation",
                      format: "gff3",
                      name: "CNV Detail",
                      url: gff3_url,
                      indexed: false,
                      height: 100,
                      displayMode: "EXPANDED",
                      visibilityWindow: -1,
                      label: feature => {
                          console.log("Feature:", feature); // Log the feature for debugging
                          console.log("Attributes:", feature.attributeString); // Log attributes

                          // Extract the type from the attributes
                          const typeMatch = feature.attributeString ? feature.attributeString.match(/type=([^;]+)/) : null;
                          return typeMatch ? typeMatch[1] : feature.id; // Return type or ID as fallback
                      },
                      itemRgb: "on" // Optional, if you want to apply RGB colors based on attributes

                    }
                  )
                }

                if (response.data["igv_cnv_bed"] !== "") {
                  options.tracks.push(
                    {
                      type: "annotation",
                      format: "bed",
                      name: "CNV Full",
                      url: bed_cnv_url,
                      indexed: false,
                      height: 100,
                      displayMode: "COLLAPSED",
                      visibilityWindow: -1,
                      label: feature => feature.name || feature.id,
                      itemRgb: "on"
                    }
                  )
                }

                igv.createBrowser(igvDiv, options)
                    .then(function (browser) {
                        igv.browser = browser;

                        // Attempt to enable the center guide explicitly if not already visible
                        if (browser.centerGuide && browser.centerGuide.$centerGuide) {
                            browser.centerGuide.$centerGuide.css('display', 'block');
                            console.log("Center guide enabled successfully.");
                        } else {
                            console.warn("Center guide not available. Please ensure your IGV.js version supports it.");
                        }

                        // Debugging output for browser properties
                        console.log("IGV Browser initialized:", browser);
                    })
                    .catch(function (error) {
                        console.error("Error creating IGV browser:", error);
                    });

                // igv.loadTrack({
                //     url: bam_url,
                //     indexURL: bai_url,
                //     name: '20S1'
                //     })

              }, error => {
                  console.log(error);
              });

        } else {
          igv.removeBrowser(browser);
        }


        // event.stopImmediatePropagation();
        // this.m_transcripts([]);
        // this.m_modal_transcripts(true);
        // this.a_anots( {"id_var": row.id_var, "er": this.er_switch } );
        // resolve(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // console.log(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // resolve(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // let mypayload = { "id_var": tree.id_var, "er": this.cufi.er_switch };

      },


      igv_search(row, event) {
        let sest = row.chrom + ":" + row.pos;
        igv.browser.search(sest);
      },


      igv_search_coord(coord) {
        igv.browser.search(coord);
      },


      ____iclass_tabs(tab, event) {
        if (tab.name == "change") {

        } else if (tab.name == "vardescription") {
          this.formdata_change_class.pane_v = true;
          axios.get(process.env.VUE_APP_BE + '/change_interpretation', { withCredentials: true, params: { "id_var": this.formdata_change_class.id_var, what: "desc" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
              .then(response => {
                this.formdata_change_class.description_v = response.data["description_v"]
              }, error => {
                  console.log(error);
              });

        } else if (tab.name == "history") {
          this.formdata_change_class.pane_v = false;
          axios.get(process.env.VUE_APP_BE + '/change_interpretation', { withCredentials: true, params: { "id_var": this.formdata_change_class.id_var, what: "hist" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
              .then(response => {
                this.ints_history_data = response.data["ints_history"]
              }, error => {
                  console.log(error);
              });

        } else if (tab.name == "partners") {
          this.formdata_change_class.pane_v = false;
          axios.get(process.env.VUE_APP_BE + '/change_interpretation', { withCredentials: true, params: { "id_var": this.formdata_change_class.id_var, what: "part" }, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', }})
              .then(response => {
                this.ints_partner_data = response.data["ints_partner"]
              }, error => {
                  console.log(error);
              });

        } else {
          this.formdata_change_class.pane_v = false;
        }
      },


      show_slider_value() {
        this.a_notify( {message: "Genes were added to Custom Filter"} );
      },


      change_var_page() {

      },


      change_collapse(mytab) {

      },


      order_select_change(value) {
        if (this.global) {
          this.m_vars_order(value);
          this.a_vars( { "order": value } );

        } else {
          this.m_vars_order(value);
          this.a_vars( { "order": value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected": this.vars_selected } );
        }
      },


      show_tab_click(tab, event){
        if ((tab.name === 'all' || tab.name === 'default' || tab.name === 'presel' || tab.name === 'sign' || tab.name === 'polyt' || tab.name === 'custom') && (tab.name === 'cnv') && (this.igv_switch)) {
          this.handle_igv();
        }

        this.pagination_v.currentPage = 1;
        if (tab.name === "all") {
          this.m_cufi_selected( 1 );
          this.m_cufi_load();
          this.m_vars_selected(null);
          this.m_cnvs_selected(null);
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );

        } else if (tab.name === "default") {
          axios.get(process.env.VUE_APP_BE + '/cufi', { withCredentials: true, params: {id_workflow: this.id_workflow}, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
            .then(response => {
              if (response.data["id_cufi_default"] > 0) {
                this.m_cufi_selected( response.data["id_cufi_default"] );
                this.m_cufi_load();
                this.m_vars_selected(null);
                this.m_cnvs_selected(null);
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );
              } else {
                this.m_cufi_selected( 1 );
                this.m_cufi_load();
                this.m_vars_selected(null);
                this.m_cnvs_selected(null);
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );
              }
            }, error => {
              console.log(error);
            });

        } else if (tab.name === "presel") {
          this.m_cufi_selected( 1 );
          this.m_cufi_load();
          this.m_vars_selected(false);
          this.m_cnvs_selected(false);
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );
          this.a_cnvs( { "selected": this.cnvs_selected } );

        } else if (tab.name === "sign") {
          this.m_cufi_selected( 1 );
          this.m_cufi_load();
          this.m_vars_selected(true);
          this.m_cnvs_selected(true);
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );
          this.a_cnvs( { "selected": this.cnvs_selected } );

        } else if (tab.name === "cnv") {
          // this.m_vars_selected(true);
          this.m_cnvs_selected(null);
          this.a_cnvs( {  } );
          this.a_dufis_get( {  } );


        } else if (tab.name === "polyt") {

        } else if (tab.name === "diag") {
          this.a_hpo_get();

        } else if (tab.name === "custom") {
          axios.get(process.env.VUE_APP_BE + '/cufi', { withCredentials: true, params: {id_workflow: this.id_workflow}, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
            .then(response => {
              if (response.data["id_cufi_default"] > 0) {
                this.m_cufi_selected( response.data["id_cufi_default"] );
                this.m_cufi_load();
                this.m_vars_selected(null);
                this.m_cnvs_selected(null);
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );
              } else {
                this.m_cufi_selected( 1 );
                this.m_cufi_load();
                this.m_vars_selected(null);
                this.m_cnvs_selected(null);
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );

              }

            }, error => {
              console.log(error);
            });

        } else {
          // axios.get(process.env.VUE_APP_BE + '/cufi', { withCredentials: true, params: {id_workflow: this.id_workflow}, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
          //   .then(response => {
          //     this.m_cufi_selected( response.data["id_cufi_default"] );
          //     this.m_cufi_load();
          //     // this.show_vars();

          //     this.m_cufi_yes(true);
          //     this.cufi.cufi_yes = true;
          //     this.m_vars_selected(null);
          //     this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );

          //   }, error => {
          //     console.log(error);
          //   });
        }
        // this.a_vars_badges( { "id_examination": this.id_examination } );

        // console.log(this.cufi_yes);
      },


      show_click(value){

      },


      select_filter_gene(value){
        this.m_ss_gene(value);
      },


      select_filter(value){
        console.log(value);
      },


      show_vars(){
        this.pagination_v.currentPage = 1;
        this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected  } );
      },


      export_setup_cols(event){
        event.stopImmediatePropagation();

        axios.get(process.env.VUE_APP_BE + '/vars_export', { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
          .then(response => {
            this.m_vars_export_all( response.data["var_cols"] );
            this.m_vars_export_my( response.data["my_var_cols"] );

            this.m_modal_vars_export( true );

          }, error => {
            console.log(error);
          });
      },


      vars_export_save(event){
        event.stopImmediatePropagation();

        axios.post(process.env.VUE_APP_BE + '/vars_export', {my_var_cols: this.vars_export_my}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
          .then(response => {
            this.m_modal_vars_export( false );
            this.$notify({
              title: 'INFO',
              message: 'Export settings saved',
              type: 'success',
              position: 'top-right',
            });
          }, error => {
            console.log(error);
          });
      },


      export_all_vars(event){
        event.stopImmediatePropagation();
        this.a_vars( { "export": 2, "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "fastras_freq": this.fastras_freq, "id_examination": this.id_examination, "id_project": this.id_project, "sample_id": this.g_examination_export.sample_id,  "selected_exams": this.selected_exams, "selected": this.vars_selected } );
      },


      export_grid_vars(event){
        event.stopImmediatePropagation();

        if (["default", "custom"].includes(this.vars_selected_tab)) {
          this.a_vars( { "export": 1, "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "fastras_freq": this.fastras_freq, "id_examination": this.id_examination, "id_project": this.id_project, "sample_id": this.g_examination_export.sample_id,  "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );
        } else {
          this.a_vars( { "export": 1, "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "fastras_freq": this.fastras_freq, "id_examination": this.id_examination, "id_project": this.id_project, "sample_id": this.g_examination_export.sample_id,  "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        }
      },


      cufi_genes_del(){
          let mykey = "genes";
          let value = [];
          this.$store.commit('m_cufi', {mykey, value});
      },


      mylink_symbol(myvar) {
        return "https://www.genecards.org/cgi-bin/carddisp.pl?gene=" + myvar ;
      },

      mylink_pubmed(pubmed) {
        return "https://pubmed.ncbi.nlm.nih.gov/?term=" + pubmed ;
      },

      mylink_clinsig(row) {
        return "http://www.ncbi.nlm.nih.gov/clinvar/?term=" + row.a_879 + "[alleleid]" ;
      },

      mylink_dbsnp(one) {
        return "http://www.ncbi.nlm.nih.gov/snp/" + one ;
      },

      mylink_varsome(row) {
        return `https://varsome.com/variant/hg38/${row.chrom}-${row.pos}-${row.ref}-${row.alt}` ;
      },

      mylink_varsome_somatic(row) {
        return `https://varsome.com/variant/hg38/${row.chrom}-${row.pos}-${row.ref}-${row.alt}?annotation-mode=somatic` ;
      },

      mylink_genebe(row) {
        return `https://genebe.net/variant/hg38/${row.chrom}:${row.pos}-${row.ref}>${row.alt}`;
      },

      mylink_franklin(row) {
        return `https://franklin.genoox.com/clinical-db/variant/snp/${row.chrom}-${row.pos}-${row.ref}-${row.alt}-hg38`;
      },

      mylink_franklin_somatic(row) {
        return `https://franklin.genoox.com/clinical-db/variant/snpTumor/${row.chrom}-${row.pos}-${row.ref}-${row.alt}-hg38`;
      },

      mylink_oncokb(row) {
        return `https://www.oncokb.org/gene/${row.a_4}/${row.mutpred}`;
      },

      mylink_pos(row) {
        return "http://www.ensembl.org/Homo_sapiens/Location/View?r=" + (row.chrom).substring(3) + ":" + row.pos + "-" + row.pos ;
      },


      mylink_hgvsc(row) {
        return "http://genome.ucsc.edu/cgi-bin/hgTracks?db=hg38&position=" + row.a_11_full + "&hgt.out3=submit" ;
      },


      mylink_transcript(row) {
        return "https://www.ncbi.nlm.nih.gov/nuccore/" + row.a_7 ;
      },


      mylink_cosmic(row) {
        return "https://cancer.sanger.ac.uk/cosmic/search?q=" + row.a_501 ;
      },


      gnomad(row) {
        return `https://gnomad.broadinstitute.org/variant/${row.chrom}-${row.pos}-${row.ref}-${row.alt}?dataset=gnomad_r4` ;
      },


      mylink_clinicaltrials(row) {
        return `https://clinicaltrials.gov/search?term=${row.chrom}:${row.pos}-${row.ref}>${row.alt}`;

      },


      mylink_google_scholar(row) {
        const terms = [];

        if (row.a_4) terms.push(row.a_4); // Gene symbol
        if (row.a_11_full) terms.push(row.a_11_full); // HGVS
        if (row.a_891) terms.push(`${row.a_891}`); // dbSNP rsID

        const query = encodeURIComponent(terms.join(" "));
        return `https://scholar.google.com/scholar?q=${query}`;
      },


      mylink_google(row) {
        const terms = [];

        if (row.a_891) terms.push(`${row.a_891}`);
        if (row.a_4) terms.push(row.a_4);
        if (row.chrom && row.pos) terms.push(`${row.chrom}:${row.pos}`);
        if (row.a_11_full) terms.push(row.a_11_full);
        if (row.a_7) terms.push(row.a_7);

        const query = encodeURIComponent(terms.join(" "));
        return `https://www.google.com/search?q=${query}`;
      },


      mylink_chatgpt(row) {
        const parts = [];

        if (row.a_891) parts.push(`dbSNP: ${row.a_891}`);
        if (row.a_4) parts.push(`Gene: ${row.a_4}`);
        if (row.chrom && row.pos) parts.push(`Genomic position: ${row.chrom}:${row.pos}`);
        if (row.a_11_full) parts.push(`HGVS: ${row.a_11_full}`);

        const query = encodeURIComponent(
          `What is known about this variant? ${parts.join(", ")}`
        );

        return `https://chat.openai.com/chat?prompt=${query}`;
      },


      mylink_pharmgkb(row) {
        return `https://www.pharmgkb.org/search?query=${row.a_4}`;
      },


      alertuj(mytext) {
        if (mytext === 1) {
          alert(mytext + " - Benign");
        } else if (mytext === 2) {
          alert(mytext + " - Likely benign");
        } else if (mytext === 3) {
          alert(mytext + " - Uncertain significance");
        } else if (mytext === 4) {
          alert(mytext + " - Likely pathogenic");
        } else if (mytext === 5) {
          alert(mytext + " - Pathogenic");
        } else {
          alert(mytext);
        }
      },


      popover_items ( mydata ) {
        let myitems = []
        for (let i of mydata.split(',')) {
          myitems.push( i.replace(/_/g, " ") );
        }
        return "<ul><li>" + myitems.join("</li><li>") + "</li></ul>";
      },


      search_vars_by( event ) {
        event.stopImmediatePropagation();
        if (this.search_vars_by_select === "") {
          this.$alert('Select item for filtering first.', 'WRONG.', {
            confirmButtonText: 'OK',
          });
        } else {
          this.pagination_v.currentPage = 1;

          if (this.vars_selected_tab === "all") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
          } else if (this.vars_selected_tab === "default") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );
          } else if (this.vars_selected_tab === "custom") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "cufi": this.cufi, "selected": this.vars_selected } );
          } else if (this.vars_selected_tab === "presel") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
          } else if (this.vars_selected_tab === "sign") {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
          } else {
            this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
          }

        }
      },


      search_vars_all( event ) {
        event.stopImmediatePropagation();
        this.search_vars_by_select = "";
        this.search_vars_by_value = "";

        if (this.vars_selected_tab === "all") {
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "default") {
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "custom") {
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else {
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
        }

      },


      sign_out_vars (event) {
        event.stopImmediatePropagation();
        var sel_vars = [];
        this.selected_vars.forEach(element => sel_vars.push(element.id_ant));

        if (this.selected_vars.length > 0) {
          axios.post(process.env.VUE_APP_BE + '/sign_out_vars', { "id_project": this.id_project, "id_examination": this.id_examination, "selected_vars": this.selected_vars }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
              .then(response => {
                if (response.data.resp_info > "") {
                  this.$alert('Variants were already signed out. Please first reset sign out to change.', 'Attention', {
                    confirmButtonText: 'OK',
                    type: "danger"
                  });
                } else {
                  this.$notify({
                    title: 'INFO',
                    message: 'Variants signed out',
                    type: 'success',
                    position: 'top-right',
                  });
                }

                this.a_examinations_refresh( {"id_project": this.id_project} );

                if (["default", "custom"].includes(this.vars_selected_tab)) {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
                } else {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
                }

              }, error => {
                  console.log(error);
              });
        } else {
          this.$alert('No variant(s) selected to be signed out.', 'Warning', {
                    confirmButtonText: 'OK',
                    type: "warning"
                  });
        }

      },


      sign_out_vars_reset (event) {
        event.stopImmediatePropagation();

        axios.put(process.env.VUE_APP_BE + '/sign_out_vars', { "id_project": this.id_project, "id_examination": this.id_examination }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
            .then(response => {
              this.$notify({
                title: 'INFO',
                message: 'Successful variant reset',
                type: 'success',
                position: 'top-right',
              });

              this.a_examinations_refresh( {"id_project": this.id_project} );

              if (["default", "custom"].includes(this.vars_selected_tab)) {
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
              } else {
                this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
              }

              this.a_cnvs( { "selected": this.vars_selected } );

            }, error => {
                console.log(error);
            });
      },


      sign_out_no_vars (event) {
        event.stopImmediatePropagation();

        axios.patch(process.env.VUE_APP_BE + '/sign_out_vars', { "id_project": this.id_project, "id_examination": this.id_examination }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
            .then(response => {
              this.$notify({
                title: 'INFO',
                message: 'Sign-out without variants was successful',
                type: 'info',
                position: 'top-right',
              });

              this.a_examinations_refresh( {"id_project": this.id_project} );
            }, error => {
                console.log(error);
            });

      },


      __preselect_vars (event) {
        event.stopImmediatePropagation();
        var sel_vars = [];
        this.selected_vars.forEach(element => sel_vars.push(element.id_ant));

        if (this.selected_vars.length > 0) {
          axios.post(process.env.VUE_APP_BE + '/preselect_vars', { "id_project": this.id_project, "id_examination": this.id_examination, "selected_vars": this.selected_vars }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
              .then(response => {
                if (response.data.resp_info > "") {
                  this.$alert('Variants were already signed out. Please first reset sign out to change.', 'Attention', {
                    confirmButtonText: 'OK',
                    type: "danger"
                  });
                } else {
                  this.$notify({
                    title: 'INFO',
                    message: 'Variants are moved to Preselected',
                    type: 'success',
                    position: 'top-right',
                  });
                }

                if (this.vars_selected_tab === "all") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "default") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "custom") {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
                } else {
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
                }

              }, error => {
                  console.log(error);
              });
        } else {
          this.$alert('No variants are selected for the Preselect.', 'Warning', {
                    confirmButtonText: 'OK',
                    type: "warning"
                  });
        }

      },


      __unpreselect_vars (event) {
        event.stopImmediatePropagation();
        var sel_vars = [];
        this.selected_vars.forEach(element => sel_vars.push(element.id_ant));

        if (this.selected_vars.length > 0) {
          axios.put(process.env.VUE_APP_BE + '/preselect_vars', { "id_project": this.id_project, "id_examination": this.id_examination, "selected_vars": this.selected_vars }, { withCredentials: true, headers: { 'Authorization': this.token, 'RouterApp': this.rapp, 'Content-Type': 'application/json;charset=UTF-8', } })
              .then(response => {
                if (response.data.resp_info > "") {
                  this.$alert('Variants were already signed out. Please first reset sign out to change.', 'Attention', {
                    confirmButtonText: 'OK',
                    type: "danger"
                  });
                } else {
                  this.$notify({
                    title: 'INFO',
                    message: 'Variants are removed from Preselected',
                    type: 'success',
                    position: 'top-right',
                  });
                }

                if (this.vars_selected_tab === "all") {
                  // this.cufi.cufi_yes = false;
                  // this.cufi.full_yes = true;
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "default") {
                  // this.cufi.cufi_yes = true;
                  // this.cufi.full_yes = true;
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
                } else if (this.vars_selected_tab === "custom") {
                  // this.cufi.cufi_yes = true;
                  // this.cufi.full_yes = true;
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
                } else {
                  // this.cufi.cufi_yes = false;
                  // this.cufi.full_yes = true;
                  this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
                }

              }, error => {
                  console.log(error);
              });
        } else {
          this.$alert('No variants are selected for the Preselect.', 'Warning', {
                    confirmButtonText: 'OK',
                    type: "warning"
                  });
        }

      },


      make_report_vars (event, sample_id) {
        event.stopImmediatePropagation();
        var my_filename = sample_id.replace(" ", "_").replace("-", "_") + "_report.pdf"
        axios.post(process.env.VUE_APP_BE + '/make_report_vars', { "id_examination": this.id_examination, "app_version": this.app_version, }, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'text/html', }, responseType: 'blob', })
            .then(response => {
                    var blob = new Blob([response.data]);
                    FileSaver.saveAs(blob, my_filename);
            }, error => {
                console.log(error);
                this.$notify({
                  title: 'INFO',
                  message: "Report can't be created.",
                  type: 'warning',
                  position: 'top-right',
                });
            });

      },


      click_acmg (event, id_var) {
        event.stopImmediatePropagation();
        this.a_acmg_data( id_var );
      },


      click_acmg_genebe (event, id_var) {
        event.stopImmediatePropagation();
        this.a_acmg_data_genebe( id_var );
      },


      click_freq_proj (row) {
        event.stopImmediatePropagation();
        this.freq_type = "List of samples sharing the same variants in current project";
        this.a_freq_data( {"row": row, "which": "proj"} );
      },


      click_freq_subj (row) {
        event.stopImmediatePropagation();
        this.freq_type = "List of samples sharing the same variants";
        this.a_freq_data( {"row": row, "which": "subj"} );
      },


      click_modal_predictors (event, id_var) {
        event.stopImmediatePropagation();
        this.a_predictors_data( id_var );
      },


      // setCurrent(row) {
      //   this.$refs.singleTable.setCurrentRow(row);
      // },
      // handleCurrentChange_p(val) {
      //   if (val && val.id_project > 0) {
      //     this.m_id_project(val.id_project);
      //     this.m_id_examination(0);
      //     this.m_pan_project(true);
      //     // this.a_examinations(val.id_project);
      //     this.project_name = val.name;
      //   } else {
      //     this.m_id_project(0);
      //     this.m_id_examination(0);
      //     this.m_pan_project(false);
      //     this.project_name = "";
      //   }
      // },

      // handleCurrentChange_e(val) {
      //   if (val && val.id_examination > 0) {
      //     this.m_id_examination(val.id_examination);
      //     this.a_vars( {"order": 1, "id_examination": val.id_examination} );
      //   } else {
      //     this.m_id_examination(0);
      //   }
      // },



      __handleCurrentChangePage_v(val) {
        this.pagination_v.currentPage = val;

        if (this.vars_selected_tab === "all") {
          // this.cufi.cufi_yes = false;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "default") {
          // this.cufi.cufi_yes = true;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "custom") {
          // this.cufi.cufi_yes = true;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else {
          // this.cufi.cufi_yes = false;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
        }

      },


      __handleSizeChangePage_v(val) {
        this.pagination_v.perPage = val;

        if (this.vars_selected_tab === "all") {
          // this.cufi.cufi_yes = false;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "default") {
          // this.cufi.cufi_yes = true;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "custom") {
          // this.cufi.cufi_yes = true;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else {
          // this.cufi.cufi_yes = false;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": 1, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
        }

      },


      __handleSelectionChange_v(val) {
        // event.stopImmediatePropagation();
        this.selected_vars = val;
      },


      __handleSortChange_v(val) {
        // console.log(this.selected_exams);

        // event.stopImmediatePropagation();
        // console.log(val);
        this.pagination_v.currentPage = 1;
        this.sorting_v.prop = val.prop;
        this.sorting_v.ord = val.order;

        if (this.vars_selected_tab === "all") {
          // this.cufi.cufi_yes = false;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "default") {
          // this.cufi.cufi_yes = true;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else if (this.vars_selected_tab === "custom") {
          // this.cufi.cufi_yes = true;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "id_project": this.id_project, "selected_exams": this.selected_exams, "selected": this.vars_selected } );
        } else {
          // this.cufi.cufi_yes = false;
          // this.cufi.full_yes = true;
          this.a_vars( { "sorting_prop": this.sorting_v.prop, "sorting_ord": this.sorting_v.ord, "perPage": this.pagination_v.perPage, "currentPage": this.pagination_v.currentPage, "fastras_freq": this.fastras_freq, "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, "id_examination": this.id_examination, "selected_exams": this.selected_exams, "id_project": this.id_project, "selected": this.vars_selected } );
        }

      },


      __toggleSelection_v(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.varsTable.toggleRowSelection_v(row);
          });
        } else {
          this.$refs.varsTable.clearSelection();
        }
      },


      handleCurrentChange_ff(val) {
        if (val && val.id_filter > 0) {
          console.log(val);
          // this.a_examinations(val.id_examination);
        } else {
          console.log(val);
          // this.m_i_examination(0);
        }
      },


      handleCurrentChange_hpo(val) {
        let skuplek = [];

        if (val) {
          for (let a of this.cufi.genes.values()) {
            skuplek.push(a);
          }
          for (let s of val.genelist) {
            if (!(skuplek.includes(s))) {
              skuplek.push(s);
            }
          }
          skuplek.sort();
          let mykey = "genes";
          let value = skuplek;
          this.$store.commit('m_cufi', {mykey, value});
        }
        this.a_notify( {message: "Genes were added to Filter"} );

        // axios.post(process.env.VUE_APP_BE + '/cufi', {cufi: this.cufi}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
        //   .then(response => {
        //     this.m_d_cufis( response.data["d_cufis"] );
        //     this.m_l_cufis( response.data["l_cufis"] );

        //     this.$notify({
        //       title: 'INFO',
        //       message: 'Filter was saved',
        //       type: 'success',
        //       position: 'top-right',
        //     });
        //   }, error => {
        //     console.log(error);
        //   });

      },


      inputFile: function (newFile, oldFile) {
        if (newFile && !newFile.active) {
          // Get response data
          console.log('response', newFile.response)
          if (newFile.xhr) {
            //  Get the response status code
            console.log('status', newFile.xhr.status)
          }
        }
      },


      cnvSortChange () {

      },


      watch_rapp () {
        if (this.rapp === "fastras") {
          this.user_setup.vars_grid_size = "S";
        } else {
          this.user_setup.vars_grid_size = "L";
        }
      },


      watch_igv_sest (newid, oldid) {
        if (newid !== oldid) {
          igv.browser.search(this.igv_sest)
        }
      },


      watch_igv_coord (newid, oldid) {
        if (newid !== oldid) {
          igv.browser.search(this.igv_coord)
        }
      },


      watch_id_examination (newid, oldid) {
        if (newid !== oldid) {
          if (this.igv_switch) {
            this.m_igv_switch(false);
          }
        }
      },


      // watch_selected_exams (newid, oldid) {
      //   if (newid.length > 0) {
      //       this.m_igv_switch(false);
      //   } else {
      //     this.m_igv_switch(true);
      //   }
      // },


      getImpactColor(impact) {
        switch (impact) {
          case 'HIGH':
            return 'red'; // High impact is red
          case 'MODERATE':
            return 'orange'; // Moderate impact is orange
          case 'LOW':
            return 'green'; // Low impact is green
          case 'MODIFIER':
            return 'blue'; // Modifier impact is blue
          default:
            return 'black'; // Fallback color for undefined impact
        }
      },


      copyToClipboard_gene(row) {
        if (row.a_4) {
          navigator.clipboard.writeText(row.a_4).then(() => {
            this.$notify({
              title: 'INFO',
              message: 'Gene symbol copied to clipboard!',
              type: 'success',
              position: 'top-right'
            });
          }).catch(() => {
            this.$notify({
              title: 'ERROR',
              message: 'Failed to copy gene symbol to clipboard.',
              type: 'error',
              position: 'top-right'
            });
          });
        } else {
          this.$notify({
            title: 'WARNING',
            message: 'No gene symbol available to copy.',
            type: 'warning',
            position: 'top-right'
          });
        }
      },


      copyToClipboard_coordinates_var(row) {
        if (row.chrom && row.pos && row.ref && row.alt) {
          // Remove 'chr' if it's already included in row.chrom
          const chrom = row.chrom.startsWith('chr') ? row.chrom.slice(3) : row.chrom;
          const coords = `chr${chrom}-${row.pos}-${row.ref}-${row.alt}`;

          navigator.clipboard.writeText(coords).then(() => {
            this.$notify({
              title: 'Copied',
              message: `Coordinates copied to clipboard.`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },


      copyToClipboard_coordinates_igv(row) {
        if (row.chrom && row.pos) {
          // Avoid double 'chr' if it's already included
          const chrom = row.chrom.startsWith('chr') ? row.chrom : `chr${row.chrom}`;
          const pos = parseInt(row.pos, 10);

          const igvStyle = `${chrom}:${pos}-${pos}`;

          navigator.clipboard.writeText(igvStyle).then(() => {
            this.$notify({
              title: 'Copied',
              message: `IGV-style coordinates copied: ${igvStyle}`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },


      copyToClipboard_hgvsp(row) {
        if (row.a_7 && row.a_12) {
          const text = `${row.a_7}:${row.a_12}`;
          navigator.clipboard.writeText(text).then(() => {
            this.$notify({
              title: 'Copied',
              message: `HGVSp copied to clipboard.`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },


      copyToClipboard_hgvsc_full(row) {
        if (row.a_11_full) {
          navigator.clipboard.writeText(row.a_11_full).then(() => {
            this.$notify({
              title: 'Copied',
              message: `HGVSc copied to clipboard.`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },


      copyToClipboard_cosmic(row) {
        if (row.a_501) {
          navigator.clipboard.writeText(row.a_501).then(() => {
            this.$notify({
              title: 'Copied',
              message: `COSMIC ID copied to clipboard.`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },


      copyToClipboard_dbsnp(row) {
        if (row.a_891) {
          const rsid = `${row.a_891}`;
          navigator.clipboard.writeText(rsid).then(() => {
            this.$notify({
              title: 'Copied',
              message: `dbSNP copied to clipboard.`,
              type: 'success',
              position: 'top-right',
            });
          });
        }
      },


      copyToClipboard_proteinImpact(row) {
        const parts = [];

        if (row.a_15) parts.push(`Protein: ${row.a_15}`);
        if (row.a_17) parts.push(`Codons: ${row.a_17}`);
        if (row.a_16) parts.push(`AA: ${row.a_16}`);

        const text = parts.length > 0 ? parts.join(', ') : 'No protein info available';

        navigator.clipboard.writeText(text).then(() => {
          this.$notify({
            title: 'Copied',
            message: `Copied: ${text}`,
            type: 'success',
            position: 'top-right',
          });
        });
      },


      copyToClipboard_cdnaCds(row) {
        const parts = [];

        if (row.a_13) parts.push(`cDNA: ${row.a_13}`);
        if (row.a_14) parts.push(`CDS: ${row.a_14}`);

        const text = parts.length > 0 ? parts.join(', ') : 'No cDNA/CDS info available';

        navigator.clipboard.writeText(text).then(() => {
          this.$notify({
            title: 'Copied',
            message: `Copied: ${text}`,
            type: 'success',
            position: 'top-right',
          });
        });
      },


      openChatGPT(row) {
        const parts = [];

        if (row.a_891) parts.push(`dbSNP: rs${row.a_891}`);
        if (row.a_4) parts.push(`Gene: ${row.a_4}`);
        if (row.chrom && row.pos) parts.push(`Genomic position: ${row.chrom}:${row.pos}`);
        if (row.a_11_full) parts.push(`HGVS: ${row.a_11_full}`);

        const prompt = `What is known about this variant? ${parts.join(", ")}`;

        // Copy to clipboard
        navigator.clipboard.writeText(prompt).then(() => {
          this.$message({
            message: 'Prompt copied to clipboard!',
            type: 'success'
          });

          // Open ChatGPT with the prompt pre-filled
          const encoded = encodeURIComponent(prompt);
          const url = `https://chat.openai.com/?model=gpt-4&prompt=${encoded}`;
          window.open(url, '_blank');
        });
      }
    },


    beforeMount () {
      // this.a_vars();
      this.m_vars([]);
      moment.locale("us");
      this.formdata_np.created_dt = moment(Date().toLocaleString()).format('LLL');
      this.a_f_filters();
    },


    created () {

    },


    mounted () {
      // var igvDiv = document.getElementById("igv-div");
      // var options =
      //     {
      //         genome: "hg38",
      //         locus: "chr8:127,736,588-127,739,371",
      //         tracks: [
      //             {
      //                 "name": "HG00103",
      //                 "url": "https://s3.amazonaws.com/1000genomes/data/HG00103/alignment/HG00103.alt_bwamem_GRCh38DH.20150718.GBR.low_coverage.cram",
      //                 "indexURL": "https://s3.amazonaws.com/1000genomes/data/HG00103/alignment/HG00103.alt_bwamem_GRCh38DH.20150718.GBR.low_coverage.cram.crai",
      //                 "format": "cram"
      //             }
      //         ]
      //     };

      //     igv.createBrowser(igvDiv, options)
      //             .then(function (browser) {
      //                 console.log("Created IGV browser");
      //             })


    },


    afterDestroy () {
      this.m_vars([]);
    },


    watch: {
      rapp: {
        handler: 'watch_rapp',
        immediate: true
      },

      id_examination: {
        handler: 'watch_id_examination',
        immediate: true
      },


      igv_sest: {
        handler: 'watch_igv_sest',
        immediate: true
      },


      igv_coord: {
        handler: 'watch_igv_coord',
        immediate: true
      },

      // selected_exams: {
      //   handler: 'watch_selected_exams',
      //   immediate: true
      // },

    },


  }
</script>

<style lang="scss" scoped>
  body {
    margin: 0;
  }

  .el-table .td-actions{
    button.btn {
      margin-right: 5px;
    }
  }

  .btn {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }

  .el-table {
    // font-size: 13px !important;
    // color: black !important;

  }

  .el-table .cell{
    line-height: 0px !important;
    word-break: break-word !important;
  }

  .el-table td, .el-table th {
    padding: 3px 0 !important;
    padding-top: 10px !important;
  }

  .el-table .row_0 {
    background: #e6e6e6 !important;
  }

  .el-table .row_1 {
    background: rgb(243, 245, 152) !important;
  }

  .el-table .row_2 {
    background: rgb(248, 221, 171) !important;
  }

  .el-table .row_3 {
    background: rgb(248, 186, 157) !important;
  }

  .el-table .row_4 {
    background: rgb(197, 248, 208) !important;
  }

  .el-table .row_9 {
    background: rgb(250, 197, 184) !important;
  }



  .el-table .warning-row {
    background: rgb(241, 175, 52) !important;
  }

  .el-table .success-row {
    background: #a7ffb9 !important;
  }

  .el-table .danger-row {
    background: #f34c19 !important;
  }

  .el-table .info-row .el-tabs--border-card {
    background: #ffece8 !important;
  }

  .hranaty {
    border-radius: 2px !important;
  }

  h4 {
    margin-top: 5px !important;
  }

  .dolu {
    padding-top: 80px !important;
  }

  .table > thead > tr > th, .el-table table > thead > tr > th {
    // font-size: 13px !important;
  }

  .mezera {
    margin-right: 10px !important;
  }

  .bottom_margin_30 {
    margin-bottom: 30px;
  }

  .bottom_margin_10 {
    margin-bottom: 10px;
  }

  .top_margin_10 {
    margin-top: 10px;
  }

  .top_margin_30 {
    margin-top: 30px;
  }

  .top_margin_50 {
    margin-top: 50px;
  }

  .bg_gray {
    background: #e2e4e5 !important;
  }

  .bg_white {
    background-color: #FFF !important;
  }

  .gene_blue {
    background-color: #ccfdf3 !important;
    margin-left: 0px !important;
    border-radius: 6px !important;
  }

  .el-tag {
      border-radius: 2px !important;
      margin-left: 3px !important;
      margin-bottom: 3px !important;
      color: black !important;
      font-weight: 600 !important;
  }

  .bg_white_tab {
    background-color: #FFF !important;
    z-index: 9999 !important;
  }

  .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #eee;
    min-height: 12px;
    padding-left: 4px !important;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 18px;
  }

  .row-bg {
    padding: 3px 0;
    background-color: #f9fafc;
  }
  .el-table .cell {
      word-break: break-word;
  }

  .small_label {
      font-size: 10px !important;
      padding-top: 2px !important;
      padding-right: 4px !important;
  }

  .min_height {
    border-radius: 4px;
    height: 30px !important;
  }

  .popover_bg {
    background: #a3bbf1;
  }

  .pagination_mezera {
    margin-top: 25px !important;
  }

  .caret-wrapper {
    display: block !important;
  }

  .igv_modra {
    color: #409EFF !important;
  }

  .badge_item {
    // margin-top: 10px;
    margin-right: 25px;
  }

  .badge_item_last {
    // margin-top: 10px;
    margin-right: 0px;
  }



  /* Custom Tooltip Styling */
  .custom-tooltip .el-tooltip__popper {
    background-color: #fff !important; /* Light background for the tooltip */
    border: 1px solid #ddd;            /* Optional: Subtle border around the tooltip */
    padding: 8px;                      /* Padding inside the tooltip */
    font-size: 14px;                   /* Adjust font size */
    color: black;                      /* Ensure the text color is black */
  }

  .custom-tooltip .el-tooltip__content {
    color: black;                      /* Ensure the content text is black */
  }

  .el-checkbox.is-bordered  {
    border: 2px solid black;
  }
</style>
